import React, { useState } from 'react';

import AiSummaryModal from './AiSummaryModal';

const AiMapPanel = () => {
	const [selectedItem, setSelectedItem] = useState(null);
	const items = [
		{ title: "Today's Summary", subtitle: "Today's fleet activity", type: 'today', active: true },
		{ title: 'Weekly Summary', subtitle: '7-day fleet overview', type: 'weekly', active: true },
		{ title: 'Monthly Report', subtitle: 'Executive overview', type: 'monthly' },
		{ title: 'Driver Insights', subtitle: 'Top drivers & risks', type: 'driver' },
		{ title: 'Ask AI', subtitle: 'Chat with AI', type: 'ask' },
	];
	const openAISummaryModal = (item) => {
		if (item.active) {
			setSelectedItem(item);
		}
	}
	const closeModal = () => setSelectedItem(null);
	const handleCardKeyDown = (event, item) => {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			openAISummaryModal(item);
		}
	}

	return (
		<>
			<div className="ai-map-panel">
				{items.map(item => (
					<div
						key={item.type}
						className={`ai-map-card ${item.type} ${item.active ? 'active' : 'disabled'}`}
						role={item.active ? 'button' : undefined}
						tabIndex={item.active ? 0 : undefined}
						onClick={() => openAISummaryModal(item)}
						onKeyDown={(event) => handleCardKeyDown(event, item)}
					>
						<span className="ai-map-card-icon">
							{item.type === 'today' && (
								<svg width="22" height="22" viewBox="0 0 24 24" fill="none" focusable="false" role="presentation"><rect x="4" y="5" width="16" height="15" rx="2" stroke="currentColor" strokeWidth="2" /><path d="M8 3v4M16 3v4M4 10h16M8 14h2M12 14h4M8 17h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /></svg>
							)}
							{item.type === 'weekly' && (
								<svg width="22" height="22" viewBox="0 0 24 24" fill="none" focusable="false" role="presentation"><path d="M5 19V9M10 19V5M15 19v-7M20 19V8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /><path d="M3 19h19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /></svg>
							)}
							{item.type === 'monthly' && (
								<svg width="22" height="22" viewBox="0 0 24 24" fill="none" focusable="false" role="presentation"><path d="M6 5h12v14H6zM8 9h8M8 12h8M8 15h8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></svg>
							)}
							{item.type === 'driver' && (
								<svg width="22" height="22" viewBox="0 0 24 24" fill="none" focusable="false" role="presentation"><path d="M12 13a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM5 21a7 7 0 0 1 14 0" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /><path d="M12 13v4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></svg>
							)}
							{item.type === 'ask' && (
								<svg width="22" height="22" viewBox="0 0 24 24" fill="none" focusable="false" role="presentation"><path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3z" fill="currentColor" /></svg>
							)}
						</span>
						<span className="ai-map-card-content">
							<span className="ai-map-card-title">{item.title}</span>
							<span className="ai-map-card-subtitle">{item.subtitle}</span>
						</span>
						<span className="ai-map-card-chevron">{String.fromCharCode(8250)}</span>
					</div>
				))}
			</div>
			{!!selectedItem &&
				<AiSummaryModal
					item={selectedItem}
					onHide={closeModal}
				/>
			}
		</>
	)
}

export default AiMapPanel;
